import React from 'react';
import './footer.scss';
import {HashLink} from 'react-router-hash-link';

import LOGO from '../../assets/sbaj_logo.svg';
import WZTBZ_LOGO from '../../assets/wstbz_logo_svg.svg';
import {ReactComponent as ELEMENT_03} from "../../assets/about/elements/ab_element_03.svg";
import {Button, InputField} from "components";
import {ReactComponent as LOCATION_ICON} from 'assets/icons/location_icon.svg';
import {ReactComponent as PHONE_ICON} from 'assets/icons/phone_icon.svg';
import {ReactComponent as EMAIL_ICON} from 'assets/icons/email_icon.svg';

const footerData: { heading: string, links: { name: string, link: string }[] }[] =
    [
        {
            heading: "Services",
            links: [
                {name: "Business Education", link: "/business-education#success"},
                {name: "Business Finance", link: "/finance"},
                {name: "Business Planning", link: "/business-education#packages_plan"},
                {name: "Start a Business", link: "/business-education#packages_start"},
                {name: "Business Growth", link: "/business-education#packages_grow"},
            ]
        },
        {
            heading: "Company",
            links: [
                {name: "About Us", link: "/about"},
                /*{name: "Contact Us", link: "#"},*/
                {name: "News", link: "/news"},
                {name: "Events", link: "/events"},
            ]
        },
        {
            heading: "Social",
            links: [
                {name: "Twitter", link: "#"},
                {name: "LinkedIn", link: "#"},
                {name: "Facebook", link: "#"},
            ]
        },
    ]

export const Footer: React.FC = () => {
    return (
        <div className={'footer'}>
            <ELEMENT_03 className={'footer_element_03'}/>
            <div className="footer_wrapper max">
                <div className="footer_wrapper_newsletter">
                    <div className="newsletter">
                        <div className="newsletter_left">
                            <span>Join our newsletter</span>
                            <p>We provide useful business education to you. </p>
                        </div>
                        <div className="newsletter_right">
                            <div className="newsletter_right_form">
                                <InputField type="text" placeholder={'Enter your email'}/>
                                <Button text={'Subscribe'} type={'primary'}
                                        onclick={() => console.log('News Letter click')}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="links">
                    <div className="links_left">
                        <div className="links_left_logo">
                            <img src={LOGO} alt=""/>
                        </div>
                        <div className="links_left_contacts">
                            <div className={'links_right_category_heading'}>
                                <h1>Contact Us</h1>
                            </div>
                            <div className="links_left_contacts_item">
                                <PHONE_ICON/>
                                <p>(876) 927-7071</p>
                            </div>
                            <div className="links_left_contacts_item">
                                <EMAIL_ICON/>
                                <p>sbajinfo@sba-jm.org</p>
                            </div>
                            <div className="links_left_contacts_item">
                                <LOCATION_ICON/>
                                <p>2 Trafalgar Road <br/> Kingston 5, Jamaica</p>
                            </div>
                        </div>
                    </div>
                    <div className="links_right">

                        {
                            footerData.map((footerData, dataIndex) => (
                                <div key={dataIndex} className={'links_right_category'}>
                                    <div className={'links_right_category_heading'}>
                                        <h1>{footerData.heading}</h1>
                                    </div>
                                    <div className={'links_right_category_routes'}>
                                        {footerData.links.map((link, linkIndex) => (
                                            // <Link key={linkIndex} to={link.link}>{link.name}</Link>
                                            <HashLink key={linkIndex} smooth to={link.link}>{link.name}</HashLink>
                                        ))}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="copyright">
                    <div className={'copyright_left'}>
                        <span>© 2022 WCL. All rights reserved.</span>
                    </div>
                    <div className={'copyright_right'}>
                    </div>
                </div>
            </div>
        </div>
    );
};
